import React from "react";

const getRatioColor = (ratio) => {
  if (ratio <= 5) return "text-green-700";
  if (ratio <= 10) return "text-green-500";
  if (ratio <= 15) return "text-yellow-500";
  if (ratio <= 20) return "text-orange-500";
  if (ratio <= 30) return "text-red-500";
  return "text-red-700";
};

const StudentSupervisionSummary = ({ data, studentsState, onJumpToStep }) => {
  const approxStudents =
    parseInt(
      studentsState.notYetConfirmedDetails?.approxNumStudents ||
        Object.keys(studentsState.studentMap || {}).length
    ) || 0;

  const attendingStaff = data.staff?.attending || [];
  const approxStaff =
    parseInt(data.staff?.staffUnknownDetails?.approxNumStaff) || 0;

  const hasStudents = studentsState.notYetConfirmed
    ? approxStudents > 0
    : Object.keys(studentsState.studentMap || {}).length > 0;

  const showWarning =
    hasStudents &&
    ((data.staff?.staffUnknown && approxStaff === 0) ||
      (!data.staff?.staffUnknown && attendingStaff.length === 0));

  return (
    <div className="mt-6 space-y-3">
      <h3 className="text-sm font-medium text-gray-700">Staff Supervision</h3>

      {showWarning && (
        <div className="text-red-700 bg-red-100 border border-red-300 p-3 rounded text-sm">
          ⚠️ No valid staff supervision declared. Please provide staff attending
          or estimated details.
        </div>
      )}

      <div className="text-sm text-gray-700 space-y-1">
        {(() => {
          const staffCount = data.staff?.staffUnknown
            ? approxStaff
            : attendingStaff.length;

          const validRatio = approxStudents > 0 && staffCount > 0;
          const ratioValue = validRatio
            ? Math.ceil(approxStudents / staffCount)
            : null;
          const ratioColor = validRatio ? getRatioColor(ratioValue) : "";

          return (
            <p>
              <strong>Ratio:</strong>{" "}
              {validRatio ? (
                <span className={`${ratioColor} font-semibold`}>
                  1:{ratioValue}
                </span>
              ) : (
                <>—</>
              )}
            </p>
          );
        })()}

        {data.staff?.staffUnknown ? (
          <>
            <p>
              <strong>Number of staff (estimated):</strong>{" "}
              {data.staff.staffUnknownDetails?.approxNumStaff || "—"}
            </p>
            <p>
              <strong>Description:</strong>{" "}
              {data.staff.staffUnknownDetails?.staffDescription || "—"}
            </p>
          </>
        ) : (
          attendingStaff.length > 0 && (
            <>
              <p>
                <strong>Number of staff (attending):</strong>{" "}
                {attendingStaff.length}
              </p>
              <ul className="space-y-1">
                {attendingStaff.map((s) => (
                  <li key={s.value}>
                    👤 {s.label}
                    {s.value === data.staff.organiser?.value && (
                      <span className="ml-2 text-blue-500 text-xs">
                        (Organiser)
                      </span>
                    )}
                  </li>
                ))}
              </ul>
            </>
          )
        )}
      </div>

      <button
        onClick={() => onJumpToStep?.(0)}
        className="text-sm text-blue-600 hover:underline mt-2"
      >
        Change staff attending
      </button>
    </div>
  );
};

export default StudentSupervisionSummary;
